import http from '@/http'
import requestUrlFunction from '@/utils/requestUrl'

export default {
  namespaced: true,
  actions: {
    async searchGifts(context, params) {
      const response = await http.get(`gift/${requestUrlFunction(params)}`)

      return response
    },
    async getGift(context, id) {
      const response = await http.get(`gift/${id}`)

      return response
    },
    async createGift(context, gift) {
      const response = await http.post(`gift/`, {
        name: gift.name,
        campaignId: gift.campaignId,
        campaignListId: gift.campaignListId,
        guideLink: gift.guideLink,
        promoCodeApplyCount: gift.promoCodeApplyCount,
        /*validUntil: formatDate(gift.validUntil),
        validTo: formatDate(gift.validTo),*/
      })

      return response
    },
    async updateGift(context, gift) {
      const response = await http.put(`gift/${gift.id}`, {
        name: gift.name,
        campaignId: gift.campaignId,
        campaignListId: gift.campaignListId,
        guideLink: gift.guideLink,
        promoCodeApplyCount: gift.promoCodeApplyCount,
        /*validUntil: formatDate(gift.validUntil),
        validTo: formatDate(gift.validTo),*/
      })

      return response
    },
    async deleteGift(context, id) {
      const response = await http.delete(`gift/${id}`)

      return response
    },
  },
}
